import { useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';

import DetailsView from '../../components/cannabisLicenses/detailsView/DetailsView';
import AppBreadcrumb from '../../components/common/breadcrumb/AppBreadcrumb';
import { PageWrapper } from '../../components/styles/Page.styled';

function LicenseDetails() {
  const { id } = useParams();

  return (
    <Container>
      <AppBreadcrumb
        mainPage="Cannabis Licenses"
        mainPageLink="/cannabis-licenses"
        viewedLicenseId={id}
      />
      <PageWrapper>
        <DetailsView />
      </PageWrapper>
    </Container>
  );
}

export default LicenseDetails;
